var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "data-import"
  }, [_vm._t("default", function () {
    return [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.showDlg
      }
    }, [_vm._v(_vm._s(_vm.text))])];
  }), _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": "",
      "width": "40%"
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_vm.dialogVisible ? _c('import-panel', {
    attrs: {
      "need-confirm": _vm.needConfirm,
      "plugins": _vm.plugins,
      "template-link": _vm.templateLink,
      "upload-name": _vm.uploadName,
      "root": this,
      "accept": _vm.accept
    },
    on: {
      "success": _vm.handleSuccess,
      "close": _vm.handleClose
    }
  }) : _vm._e()], 1)], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };